import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import coupons from 'views/management/coupons/coupons'; // Importing coupons view
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the coupons view.
 * @extends JetView
 */
export default class couponsView extends JetView {
    /**
     * Configures the layout of the coupons view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            css: 'int-left', // CSS class for styling
            Width: 250, // Width of the left panel
            responsiveCell: false, // Disables responsive behavior for this cell
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applies the current theme
                    elements: [
                        { view: 'label', label: _('Cupones') }, // Label for the toolbar
                        {
                            type: 'wide', // Type of the element
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Icon type
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Icon width
                                    height: 30, // Icon height
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                coupons, // Including the coupons view
            ],
        };

        webix.ui.fullScreen(); // Sets the UI to full screen mode

        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // Form view
            scroll: 'y', // Enables vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive behavior based on the identifier
                    type: 'wide', // Type of the element
                    cols: [left], // Left panel configuration
                },
            ],
        };
    }

    /**
     * Initializes the coupons view.
     */
    init() {}
}

// FILE DOCUMENTED
